import React from 'react'

// import CreditCard from './CreditCard'
import UnknownCard from './UnknownCard'

import Visa from './Visa'
import Maestro from './Maestro'
import MasterCard from './MasterCard'
import AmericanExpress from './AmericanExpress'
import SIM from './SIM'
import Paypal from './Paypal'
import CashIcon from './CashIcon'
import ApplePay from './ApplePay'
import GooglePay from './GooglePay'

import {
  colors,
} from '@sart/styles'

export default function CreditCartType(props) {
  const { type, color, ...rest } = props

  switch (type) {
    case 'paypal':
      return <Paypal width="28" height="22" {...rest} />

    case 'visa':
      return <Visa width="28" height="22" {...rest} />

    case 'CREDITO/BANCO EXTRANJERO/Visa':
      return <Visa width="28" height="22" {...rest} />

    case 'maestro':
      return <Maestro width="28" height="22" {...rest} />

    case 'mastercard':
      return <MasterCard width="28" height="22" {...rest} />

    case 'CREDITO/BANCO EXTRANJERO/MasterCard':
      return <MasterCard width="28" height="22" {...rest} />

    case 'american-express':
      return <AmericanExpress width="28" height="22" {...rest} />

    case 'balance':
    case 'sim':
        return <SIM {...rest} width="28" height="22" {...rest}/>

    case 'cash':
        return <CashIcon color={colors.srGreen} {...rest} width="28" height="22" {...rest} />

    case 'applePay': 
      return <ApplePay />

    case 'googlePay': 
      return <GooglePay />
    
    default:
      return <UnknownCard color={color} {...rest} />
  }
}
